import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { SystemClusterConfig } from "@graylog/server-api";
const QUERY_KEY = ["system", "cluster_config"];
const useClusterConfig = (key) => useQuery({
  queryKey: [...QUERY_KEY, key],
  queryFn: () => SystemClusterConfig.read(key)
});
export const useUpdateClusterConfig = (key) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (config) => SystemClusterConfig.update(key, config),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...QUERY_KEY, key]
      });
    }
  });
};
export default useClusterConfig;
